import React from 'react';
import { Shield } from 'lucide-react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-20 px-4 bg-brand-ink text-brand-cream relative overflow-hidden" data-id="element-159">
      <div className="absolute inset-0 grain pointer-events-none" data-id="element-160"></div>

      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center gap-8 text-center" data-id="element-161">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="w-44 h-44 shrink-0 rounded-full flex flex-col items-center justify-center border border-brand-gold/60 relative" style={{
        background: 'rgba(212, 168, 67, 0.04)'
      }} data-id="element-162">
          <Shield size={48} className="mb-1 text-brand-gold glow-gold" data-id="element-163" />
          <span className="font-display font-black text-4xl leading-none text-brand-gold glow-gold" data-id="element-164">
            7
          </span>
          <span className="font-bold uppercase tracking-[0.3em] text-xs text-brand-gold mt-1 glow-gold" data-id="element-165">
            DÍAS
          </span>
        </motion.div>

        <h2 className="font-display text-3xl sm:text-5xl font-black tracking-tight text-brand-gold glow-gold" data-id="element-166">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="text-brand-cream/90 text-base sm:text-lg leading-relaxed space-y-1" data-id="element-167">
          <p data-id="element-168">Abrís los tomos.</p>
          <p data-id="element-169">Cocinás las recetas.</p>
          <p data-id="element-170">Disfrutás la mesa sin culpa.</p>
        </div>

        <p className="text-base sm:text-lg leading-relaxed text-brand-cream/85" data-id="element-171">
          Si en 7 días no es exactamente lo que esperabas:
        </p>

        <ul className="space-y-2 text-brand-gold font-bold text-lg glow-gold" data-id="element-172">
          <li data-id="element-173">✦ Devolución del 100%</li>
          <li data-id="element-174">✦ Sin formularios</li>
          <li data-id="element-175">✦ Sin drama</li>
        </ul>

        <p className="text-brand-cream/80 italic text-sm sm:text-base max-w-md" data-id="element-176">
          Nosotras asumimos el riesgo. Vos solo tenés que animarte.
        </p>

        <p className="text-brand-cream/30 text-xs tracking-wide mt-4" data-id="element-177">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </section>;
}